var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yyds"},[_c('div',{staticClass:"user-nav-box"},[_c('MessageBox')],1),_vm._v(" "),_c('div',{staticClass:"user-conent-box"},[_c('ConentBox')],1),_vm._v(" "),_c('div',{staticClass:"user-extension-box"},[_c('ExtensionBox')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e786c0f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/tohome/yyds.vue
// module id = null
// module chunks = 